import { render, staticRenderFns } from "./PolicyAppendix.vue?vue&type=template&id=533f3ade"
import script from "./PolicyAppendix.vue?vue&type=script&lang=js"
export * from "./PolicyAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports